/**
 * Catalog names for services and variants.
 *
 * Curated catalog rows use their English `name` as a translation key. Rows a
 * supplier added through the catalog skill have no key in the translation
 * files; they carry their Hebrew name in `name_he` instead. So: translate the
 * key, and when there is no translation fall back to `name_he` in the Hebrew
 * UI, or to the English name otherwise.
 */
export const catalogName = (t, key, { ns, nameHe, language } = {}) => {
  if (!key) return nameHe || "";
  const useHebrew = language === "he" && Boolean(nameHe);
  return t(key, { ns, defaultValue: useHebrew ? nameHe : key });
};

/**
 * Picks the current language's text from a `{ en, he }` pair (the shape the
 * catalog skill API returns), falling back to the other language.
 */
export const pickLang = (pair, language) => {
  if (!pair) return "";
  if (typeof pair === "string") return pair;
  return (language === "he" ? pair.he || pair.en : pair.en || pair.he) || "";
};
